<template>
  <div>
    <header>
      <nav class="navbar navbar-dark bg-dark shadow navbar-expand-sm">
        <div class="container">
          <router-link :to="{name: 'Welcome'}" class="navbar-brand">
            <img
              src="/images/bbva-logo.svg"
              height="40"
              class="d-inline-block align-top"
              alt="Logo"
            >
          </router-link>
          <!-- <button @click="toggleNav = !toggleNav" class="navbar-toggler" type="button">
            <i v-if="toggleNav" class="material-icons">more_vert</i>
            <i v-else class="material-icons">close</i>
          </button> -->
          <div class="form-inline ml-auto">
            <!-- <router-link class="btn btn-primary" :to="{name: 'Verify'}">
              Mis entradas
            </router-link> -->
          </div>
          <!-- <div class="navbar-collapse" :class="{collapse: toggleNav}">
            <ul class="navbar-nav mt-3 mt-sm-0 ml-auto">
              <li class="nav-item">
                <router-link class="nav-link active" :to="{name: 'Tickets'}">
                  Mis entradas
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'Home'}">
                  Términos y Condiciones
                </router-link>
              </li>
            </ul>
          </div> -->
        </div>
      </nav>
    </header>
    <main>
      <slot></slot>
    </main>
    <footer>
      <div class="bg-dark py-3">
        <div class="container">
          <div class="row align-items-center">
            <div class="col text-center text-md-left">
              <ul class="nav-footer small">
                <li class="nav-item">
                  <a class="nav-link" href="https://reclamos.joinnus.com" target="_blank">
                    <img height="20" src="/images/libro-reclamos.png" alt="lr">
                    <span class="ml-2">Libro de Reclamaciones</span>
                  </a>
                </li>
                <!-- <li class="nav-item">
                  <a class="nav-link" :href="termsPdfBbva" target="_blank">
                    Términos y condiciones
                  </a>
                </li> -->
                <!--<li class="nav-item">
                  <a class="nav-link" href="#" target="_blank">
                    ¿Qué SÍ y que NO llevar al estadio?
                  </a>
                </li>-->
              </ul>
            </div>
            <div class="col-12 col-md-auto text-center text-md-right">
              <img
                src="/images/bbva-logo.svg"
                height="45"
                class="d-inline-block"
                alt="Jn"
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toggleNav: true,
    };
  },
};
</script>
